import httpRestConfig from '@jswork/http-rest-config';
import Adapter from './adapter';
import Config from './schema';

export default nx.declare({
  statics: {
    apis: {},
    init() {
      nx.$api = this.apis;
      httpRestConfig(this.apis, Adapter.getInstance(), Config);
    },
  },
});
